var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.6765 0H6.32353C2.83294 0 0 2.8 0 6.25V28.75C0 32.2 2.83294 35 6.32353 35H14.8729L18.8188 31.1C20.3112 29.625 22.7141 29.625 24.1812 31.1L28.1271 35H36.6765C40.1671 35 43 32.2 43 28.75V6.25C43 2.8 40.1671 0 36.6765 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.4064 33.3488C21.8884 32.8837 21.0857 32.8837 20.5677 33.3488L15.3884 38C14.8705 38.4651 14.8705 39.186 15.3884 39.6512C15.9064 40.1163 16.7092 40.1163 17.2271 39.6512L21.5 35.814L25.7729 39.6512C26.2908 40.1163 27.0936 40.1163 27.6116 39.6512C28.1295 39.186 28.1295 38.4651 27.6116 38L22.4323 33.3488H22.4064Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.2f0596bc894b9281da3bd72886d80f70.svg";
export { ForwardRef as ReactComponent };